import Autocomplete from "@mui/material/Autocomplete";
import useTheme from "@mui/material/styles/useTheme";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { useAddInState } from "../AddInStateProvider";
import { useGroups } from "@/hooks/groups/useGroups";

export function GroupSelect() {
  const { t } = useTranslation();
  const { data: allGroups = [] } = useGroups();
  const { groups, updateGroups } = useAddInState();
  const theme = useTheme();
  return (
    <Autocomplete
      id="group-search"
      size="small"
      multiple
      value={groups ?? []}
      onChange={(_, value) => updateGroups(value)}
      sx={{
        width: "100%",
        minWidth: "300px",
        maxWidth: "400px",
        backgroundColor: theme.palette.primary.main,
        "& .MuiAutocomplete-popupIndicator": {
          color: "white",
        },
        "& .MuiInputBase-input": { color: "white" },
        "& .MuiChip-label": {
          color: "white",
        },
        "& .MuiChip-deleteIcon": {
          color: "white",
        },
        "& .MuiAutocomplete-clearIndicator": {
          color: "white",
        },
        "& .MuiChip-root, & .MuiAutocomplete-tag": {
          color: "white",
        },
        "& .MuiAutocomplete-tag.MuiTypography-root": {
          color: "white",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": { borderColor: theme.palette.primary.main },
          "&:hover fieldset": { borderColor: theme.palette.primary.main },
          "&.Mui-focused fieldset": { borderColor: theme.palette.primary.main },
        },
      }}
      options={allGroups}
      limitTags={1}
      getOptionKey={option => option.id}
      getOptionLabel={option => option.name ?? ""}
      filterSelectedOptions
      disableCloseOnSelect
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => (
        <TextField {...params} placeholder={t("faultOverview.groupSearchPlaceholder")} />
      )}
    />
  );
}
